import appConfig from '@src/app.config.ES6';

export default {
  APP_VERSION: '1.0.0',

  GET_TRAINER_ID: `/auth/whoami`,

  // PUBLIC ENDPOINTS
  SIGNUP_URL: `${appConfig.API_BASE_URL}/signup`,
  FORGOT_PASSWORD_URL: `${appConfig.API_BASE_URL}/api/Accounts/embedReset`,
  USER_LOGIN_URL: `${appConfig.API_BASE_URL}/api/Accounts/login`,
  VALIDATE_AUTH_TOKEN_URL: `${appConfig.API_BASE_URL}/api/auth/token`,
  PUBLIC_RECIPE_DETAIL: `${appConfig.API_BASE_URL}/api/publics/recipe`,
  PUBLIC_PLATELIST_SUMMARY: `${appConfig.API_BASE_URL}/api/platelists/:id/summary`,
  GET_USER_BY_NUTRITION_TOKEN: `${appConfig.TANDEM_API_BASE_URL}/api/user/nutrition?token=:nutritionToken&realm=:clientName`,

  // PROFILE ENDPOINTS
  GET_USER_PROFILE_URL: `${appConfig.API_BASE_URL}/api/profiles/current`,
  UPDATE_USER_PROFILE_URL: `${appConfig.API_BASE_URL}/api/profiles/current/update`,

  // PREFERENCES ENDPOINTS
  GET_PREFERENCE_CATEGORIES: `${appConfig.API_BASE_URL}/api/PreferenceCategories`,
  GET_PREFERENCES: `${appConfig.API_BASE_URL}/api/ProfilePreferences/get`,
  UPDATE_PREFERENCES: `${appConfig.API_BASE_URL}/api/ProfilePreferences/updatePreferences`,

  // GROCERY ENDPOINTS
  GROCERY_LIST_URL: `${appConfig.API_BASE_URL}/api/profiles/current/grocery-list`,
  GROCERY_LIST_URLSHARE: `${appConfig.API_BASE_URL}/api/profiles/current/grocery-list/share`,
  CREATE_GROCERY_LIST_ITEM_URL: `${appConfig.API_BASE_URL}/api/profiles/current/grocery-list/add`,
  UPDATE_GROCERY_LIST_ITEM_URL: `${appConfig.API_BASE_URL}/api/profiles/current/grocery-list/grocery-item`,
  DELETE_GROCERY_LIST_ITEM_URL: `${appConfig.API_BASE_URL}/api/profiles/current/grocery-list/deleteIds`,
  ADD_GROCERY_LIST_STAPLE_ITEM_URL: `${appConfig.API_BASE_URL}/api/profiles/current/grocery-list/addStapleItem`,

  // SHOPPING ENDPOINTS
  GET_SHOPPING_DATA_URL: `${appConfig.API_BASE_URL}/api/profiles/current/shopping/getShoppingData`,

  // USER PLAN ENDPOINTS
  PLAN_WEEK_GRID_URL: `${appConfig.API_BASE_URL}/api/profiles/current/planWeekGrid`,
  CLEAR_USER_PLAN_URL: `${appConfig.API_BASE_URL}/api/profiles/current/clearMyPlan`,

  // DISHES ENDPOINTS
  DISHES_URL: `${appConfig.API_BASE_URL}/api/profiles/current/dishes`,
  DISHES_FILTERS_URL: `${appConfig.API_BASE_URL}/api/profiles/current/filters?navigationRoot=All Dishes`,
  ADD_DISH_URL: `${appConfig.API_BASE_URL}/api/profiles/current/plan-days/addDish?isPremium=true`,
  REMOVE_DISH_URL: `${appConfig.API_BASE_URL}/api/profiles/current/plan-days/removeDish?isPremium=true`,

  // PLATELIST ENDPOINTS
  PLATELIST_DAYS_URL: `${appConfig.API_BASE_URL}/api/platelists/:id/platelistdays`,
  PLATELIST_DISCOVERY_URL: `${appConfig.API_BASE_URL}/api/publics/platelistDiscovery`,
  PLATELIST_APPLY_URL: `${appConfig.API_BASE_URL}/api/profiles/current/platelist/apply`,
  PLATELIST_UNLOCK_URL: `${appConfig.API_BASE_URL}/api/profiles/current/platelist/:id/unlock`,

  // PIN/FAVORITE DISHES ENDPOINTS
  FAVORITE_DISHES_URL: `${appConfig.API_BASE_URL}/api/profiles/current/favoriteMeals_v2`,
  ADD_FAVORITE_DISH_URL: `${appConfig.API_BASE_URL}/api/profiles/current/pinMeals_v2`,
  REMOVE_FAVORITE_DISH_URL: `${appConfig.API_BASE_URL}/api/profiles/current/unPinMeals_v2`,

  // RECIPES
  RECIPES_URL: `${appConfig.API_BASE_URL}/api/recipes`,
  RECIPE_SOURCE_HEADERS_URL: `${appConfig.API_BASE_URL}/api/profiles/current/getSourcedRecipeHeaders`,

  // MEALS
  MEALS_URL: `${appConfig.API_BASE_URL}/api/meals`,

  // PLANNED DISH DETAILS
  PLANNED_DISHES_URL: `${appConfig.API_BASE_URL}/api/profiles/current/plan-dish`,

  // SHARE ENDPOINTS
  GENERATE_MEAL_SHARE_URL: `${appConfig.API_BASE_URL}/api/profiles/current/Mealshare/create`,
  GENERATE_RECIPE_SHARE_URL: `${appConfig.API_BASE_URL}/api/profiles/current/Recipeshare/create`,
};
